import "@fortawesome/fontawesome-free/css/all.min.css";
import { Route, Routes, Navigate } from "react-router-dom";
import MainLayout from "./components/layouts/MainLayout/MainLayout";
import SearchProvider from "./contexts/searchContext";
import "./index.css";
import { publicRoutes } from "./routes/publicRoutes";
import "@fontsource/montserrat";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/400-italic.css";
import ScrollToTop from "./components/elements/ScrollToTop/ScrollToTop";
import ProjectDetailsPage from "./containers/Ourprojects/ProjectDetails";
import ProjectListPage from "./containers/Ourprojects/ProjectListPage";
import { CategoryProvider } from "./contexts/CategoryContext";
import CompletedSubcategoryPage from "./containers/Ourprojects/CompletedSubcategoryPage";
import SanityServiceDetailPage from "./containers/Services/SanityServiceDetailPage";
import SanityProductDetailPage from "./containers/Products/SanityProductDetailPage"; // ✅ Import product detail page
import ScrollProgressBar from "./components/ScrollProgressBar";
import LoaderWithText from "./components/Loader/LoaderWithText";
import { PageLoadingProvider } from "./contexts/PageLoadingContext";
import { usePageLoading } from "./hooks/usePageLoading";
import NavbarOld from "./components/elements/Navbar/NavbarOld";
import { CookieConsentProvider } from "./contexts/CookieConsentContext";
import CookieConsentBanner from "./components/elements/CookieConsentBanner/CookieConsentBanner";

function AppContent() {
  const { isLoading, loadingPage } = usePageLoading();
  
  return (
    <div className="App" style={{ backgroundColor: '#eeeeee', minHeight: '100vh' }}>
      {isLoading && (
        <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
          <div className="text-center flex flex-col items-center">
            <LoaderWithText text="SHEEL" size="large" animated={true} color="#25b09b" textColor="#ffffff" />
                          <p className="mt-2 text-custom-secolor text-md text-center">
                {loadingPage === 'Welcome' ? `${loadingPage}...` : loadingPage ? `Loading ${loadingPage}...` : 'Loading...'}
              </p>
          </div>
        </div>
      )}
      <div style={{ display: isLoading ? 'none' : 'block' }}>
        <SearchProvider>
          <CategoryProvider>
            <CookieConsentProvider>
              <ScrollProgressBar />
              <Routes>
              <Route path="/" element={<MainLayout />}>
                {publicRoutes.map((route) => (
                  <Route key={route.path} path={route.path} element={route.component} />
                ))}
                <Route path="/gallery" element={<Navigate to="/gallery"/>} />
                <Route path="/projects" element={<ProjectListPage />} />
                <Route path="/projects/completed-subcategories" element={<CompletedSubcategoryPage />} />
                <Route path="/projects/:slug" element={<ProjectDetailsPage />} />

                <Route path="/services" element={<SanityServiceDetailPage />} />
                <Route path="/services/:slug" element={<SanityServiceDetailPage />} />

                {/* ✅ Add product detail route here */}
                <Route path="/products/:slug" element={<SanityProductDetailPage />} />
              </Route>
            </Routes>
            
            <ScrollToTop />
            <CookieConsentBanner />
            </CookieConsentProvider>
          </CategoryProvider>
        </SearchProvider>
      </div>
    </div>
  );
}

function App() {
  return (
    <PageLoadingProvider>
      <AppContent />
    </PageLoadingProvider>
  );
}

export default App;
